<a [href]="email" (click)="this.dialogRef.close()">Send a Message</a>